import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { trackAddToCart } from '../utils/metaPixel';
import { CHECKOUT_URL } from '../utils/checkout';
export function FinalCTA() {
  return <section id="final-cta" className="py-32 px-4 relative overflow-hidden scroll-mt-16" data-id="element-51" data-mp="c7tv9kju0su1">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-green-900/20 via-background to-background -z-10" data-id="element-52" data-mp="84e2izavvcmm" />

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-4xl mx-auto text-center" data-id="element-53" data-mp="h654bt2ayzb7">
        <h2 className="text-4xl md:text-6xl font-extrabold mb-6 tracking-tight" data-id="element-54" data-mp="qy18nluzflnv">
          The Second Half is <br className="md:hidden" data-id="element-55" data-mp="zwd544ij5do8" />
          <span className="text-green-400" data-id="element-56" data-mp="zx4s4qy2a32w">Yours for the Taking.</span>
        </h2>

        <p className="text-xl text-gray-400 mb-10 font-medium" data-id="element-57" data-mp="2c56cy8srgdli">
          Join the Reboot. Reclaim the Edge. Finish 2026 Strong.
        </p>

        <Button href={CHECKOUT_URL} onClick={() => trackAddToCart()} className="text-lg md:text-xl px-10 py-5 w-full md:w-auto" data-id="element-58" data-mp="2h49iducnklu0">
          START MY SECOND-HALF REBOOT ($27)
        </Button>
      </motion.div>
    </section>;
}